import { styled } from "@mui/system";
import { normalScrollHeight } from "../../constants";
export const transitionDuration = 400;

export const StyledVerticalPaginationWrapper = styled("div")(
  ({ theme, isMobileNotificationActive }) => ({
    position: "relative",
    "& .childWrapper": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "start",
      position: "relative",
      boxSizing: "border-box",
      minHeight: 1,
      "&:last-of-type": {
        marginBottom: 0
      },
      [theme.breakpoints.up("sm")]: {
        minHeight: "100vh",
        // Only apply height:1px for IE11
        "@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)": {
          height: "1px"
        }
      },
      [theme.breakpoints.only("xs")]: {
        marginTop: "1.5rem",
        marginBottom: "3.75rem"
      },
      [theme.breakpoints.between("xl", "lg")]: {
        padding: "18vh 20px"
      },
      [theme.breakpoints.only("xs")]: {
        height: "auto"
      },
      [`${theme.breakpoints.only("xs")}, (max-height: ${normalScrollHeight}px)`]: {
        marginBottom: 40,
        height: "auto"
      },
      "&.videoWrapper": {
        [theme.breakpoints.only("xs")]: {
          height: isMobileNotificationActive ? 444 : 380,
          marginBottom: 40
        }
      }
    }
  })
);
